import {colClients, colReferrals, functions} from "@/assets/utils/firebase.utils";
import {getCountFromServer, getDocs, limit, onSnapshot, orderBy, query, startAfter, where,} from "firebase/firestore";
import {httpsCallable} from "firebase/functions";
import {mapDocs, sortAlpha} from "@/assets/utils/doc.utils";

let unsubscribeReferrals = null;
export default {
  state: {
    _referralsList: [],
    referrals: [],
    total: 0,
    currentPage: 1,
    perPage: 10,
    firstDoc: null,
    lastDoc: null,
    loading: false,
  },
  getters: {
    getReferrals(state) {
      return state.referrals;
    },
    getReferralsTotal(state) {
      return state.total;
    },
    getReferralsPerPage(state) {
      return state.perPage;
    },
    referralsList: (state) => sortAlpha(state._referralsList),
    getReferralName(state) {
      return (id) => {
        let referral = state._referralsList.find((i) => i.id == id);
        return referral ? referral.name : "";
      };
    },
  },
  mutations: {},
  actions: {
    async fetchReferrals({ state }, payload) {
      try {
        console.log(payload);
        state.currentPage = payload?.page || 1;
        state.perPage = payload?.itemsPerPage || state.perPage;
        state.loading = true;
        const constraints = [
          orderBy("created_at", "desc"),
          limit(state.perPage),
        ];

        if (state.currentPage > 1 && state.lastDoc) {
          constraints.splice(
            constraints.length - 1,
            0,
            startAfter(state.lastDoc)
          );
        }

        const q = query(colReferrals, ...constraints);
        const snapshot = await getDocs(q);
        state.referrals = await Promise.all(
            snapshot.docs.map(async (doc) => {
              const data = doc.data();

              // 🔹 получаем клиентов по referral_id
              const clientsQuery = query(
                  colClients,
                  where("referral_id", "==", doc.id)
              );

              const clientsSnap = await getDocs(clientsQuery);

              const clients = clientsSnap.docs.map(clientDoc => {
                const clientData = clientDoc.data();
                return {
                  id: clientDoc.id,
                  full_name: `${clientData.first_name} ${clientData.last_name}`,
                };
              });


              return {
                id: doc.id,
                full_name: `${data.first_name} ${data.last_name}`,
                email: data.email,
                created_at: data.created_at ? data.created_at.toDate() : null,
                client_ids: clients.map(c => c.id),
                client_names: clients.map(c => c.full_name).join(", "),
                transaction_amount: data.transaction_amount || 0,
              };
            })
        );

        state.firstDoc = snapshot.docs[0] || null;
        state.lastDoc = snapshot.docs[snapshot.docs.length - 1] || null;

        if (state.currentPage === 1) {
          const countSnap = await getCountFromServer(colReferrals);
          state.total = countSnap.data().count;
        }
      } catch (error) {
        console.error("Error fetching referrals:", error);
      } finally {
        state.loading = false;
      }
    },
    async listenReferrals({ state }) {
      if (unsubscribeReferrals != null) return;
      let q = query(colReferrals);
      unsubscribeReferrals = onSnapshot(q, (snap) => {
        state._referralsList = mapDocs(snap.docs).map((i) => {
          return {
            ...i,
            name: `${i.first_name} ${i.last_name}`,
          };
        });
      });
    },
    resetReferralsList({ state }) {
      state._referralsList = [];
      if (unsubscribeReferrals) unsubscribeReferrals();
      unsubscribeReferrals = null;
    },
    async deleteReferral({ state }, referralId) {
      const manageReferral = httpsCallable(functions, "manageReferral");
      await manageReferral({ action: "delete", data: { id: referralId } });
      state.page = 1;
      state.referrals = state.referrals.filter((i => i.id !== referralId));
    },
  },
};
